<template>
  <div class="dashboard">
    <!-- 第一行：用户信息 + 待办事项 -->
    <el-row :gutter="20" style="margin-top: 4vh;">
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>用户信息</span>
          </div>
          <div class="user-info">
            <el-avatar :src="user.avatar || ''" size="large"></el-avatar>
            <div class="info">
               <div class="role">{{ user.role }}</div>
              <div class="name">{{ user.name }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>待办事项</span>
          </div>
          <div class="todo-list">
            <div class="todo-item">
              <span>店铺审核</span>
              <el-badge :value="todo.shop_pending" class="item">
                <el-button size="small" type="primary" plain @click="gotoShopList">
                  待审核
                </el-button>
              </el-badge>
            </div>
            <div class="todo-item">
              <span>证件审核</span>
              <el-badge :value="todo.card_pending" class="item">
                <el-button size="small" type="primary" plain @click="gotoCardList">
                  待审核
                </el-button>
              </el-badge>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 第二行：店铺图表 + 证件图表 -->
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>店铺审核统计</span>
          </div>
          <div ref="shopChart" style="height: 400px;"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>证件审核统计</span>
          </div>
          <div ref="cardChart" style="height: 400px;"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const Request = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})

export default {
  name: 'Dashboard',
  data () {
    return {
      user: { name: '', avatar: 'https://api.gud.91comerp.com/index/upload/02_dian/6a29013d6bfba_1781072189.jpg', role: '超级管理员' },
      todo: { shop_pending: 0, card_pending: 0 },
      shopStats: { pending: 0, approved: 0, rejected: 0 },
      cardStats: { pending: 0, approved: 0, rejected: 0 },
      shopChartInstance: null,
      cardChartInstance: null
    }
  },
  mounted () {
    this.fetchData()
    this.user.name = localStorage.getItem('user_name')
  },
  beforeDestroy () {
    if (this.shopChartInstance) {
      this.shopChartInstance.dispose()
      this.shopChartInstance = null
    }
    if (this.cardChartInstance) {
      this.cardChartInstance.dispose()
      this.cardChartInstance = null
    }
  },
  methods: {
    async fetchData () {
      const response = await Request.post('https://api.gud.91comerp.com/index/home_jiben_list.php')
      if (response.data.code === 0) {
        const data = response.data
        this.todo = data.todo
        this.shopStats = data.shop_chart
        this.cardStats = data.card_chart
        this.$nextTick(() => {
          this.initCharts()
        })
      }
    },
    initCharts () {
      // ---- 店铺扇形图 ----
      if (!this.shopChartInstance) {
        this.shopChartInstance = echarts.init(this.$refs.shopChart)
      }
      const shopPieData = [
        { name: '待审核', value: this.shopStats.pending },
        { name: '已审核', value: this.shopStats.approved },
        { name: '已拒绝', value: this.shopStats.rejected }
      ]
      this.shopChartInstance.setOption({
        tooltip: { trigger: 'item', formatter: '{a} <br/>{b}: {c} ({d}%)' },
        legend: { orient: 'vertical', left: 'left' },
        series: [
          {
            name: '店铺审核状态',
            type: 'pie',
            radius: '50%',
            data: shopPieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}\n{d}%'
            }
          }
        ]
      })

      // ---- 证件扇形图 ----
      if (!this.cardChartInstance) {
        this.cardChartInstance = echarts.init(this.$refs.cardChart)
      }
      const cardPieData = [
        { name: '待审核', value: this.cardStats.pending },
        { name: '已审核', value: this.cardStats.approved },
        { name: '已拒绝', value: this.cardStats.rejected }
      ]
      this.cardChartInstance.setOption({
        tooltip: { trigger: 'item', formatter: '{a} <br/>{b}: {c} ({d}%)' },
        legend: { orient: 'vertical', left: 'left' },
        series: [
          {
            name: '证件审核状态',
            type: 'pie',
            radius: '50%',
            data: cardPieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}\n{d}%'
            }
          }
        ]
      })
    },
    gotoShopList () {
      this.$router.push('/system/user')
    },
    gotoCardList () {
      this.$router.push('/system/menu')
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard {
  padding: 20px;
  .box-card {
    height: 100%;
  }
  .user-info {
    display: flex;
    align-items: center;
    .info {
      margin-left: 20px;
      .name {
        font-size: 18px;
        font-weight: bold;
      }
      .role {
        color: #909399;
        font-size: 14px;
      }
    }
  }
  .todo-list {
    display: flex;
    justify-content: space-around;
    .todo-item {
      display: flex;
      align-items: center;
      gap: 10px;
      span {
        font-size: 14px;
        color: #606266;
      }
    }
  }
}
</style>
